/* eslint-disable react/prop-types */
import { useState, useCallback } from "react";
import {
  Modal,
  Button,
  MultiSelect,
  LoadingOverlay,
  Group,
} from "@mantine/core";
import { TextInput, Text } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { getDomainList } from "../../api/auth";
import { lcaConfirmProfile } from "../../api/lcaAuth";
import { useEffect } from "react";
import Toast from "../Toast";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export function ConfirmModal({ openReg, setOpenReg, resData }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState();
  const [department, setDepartment] = useState("");
  const [isMentor, setIsMentor] = useState("");
  const [type, setType] = useState("");
  const [domains, setDomains] = useState([]);
  const [domainList, setDomainList] = useState([]);
  const [userLoad, setUserLoad] = useState(false);
  const [readmore, setReadmore] = useState(true);
  const [noteText, setNoteText] = useState(
    "Note: Software domain includes sub domains like App"
  );
  const { executeRecaptcha } = useGoogleReCaptcha();
  useEffect(() => {
    // Make api call to get the list
    // console.log(resData.name);
    if (resData) {
      // Update the state variables with the values from the response data
      setName(resData.name);
      setPhone(resData.phone);
      setGender(resData.gender);
      setDepartment(resData.department);
      setIsMentor(resData.isMentor);
      setType(resData.type);
    }
    const getBasicDetails = async () => {
      const domainData = await getDomainList();
      let domainList = [];
      //console.log(domainData);
      for (const domain of domainData.data.domains) {
        domainList = [
          ...domainList,
          { value: `${domain.id}`, label: domain.name },
        ];
      }
      setDomainList(domainList);
    };
    getBasicDetails();
  }, [resData]);

  const handleDomainChange = (selectedDomains) => {
    // console.log(selectedDomains);
    setDomains(selectedDomains);
  };

  const handleSubmit = useCallback(async () => {
    if (!executeRecaptcha) {
      //console.log("Execute recaptcha not yet available");
      return;
    }
    const ReCaptchaToken = await executeRecaptcha("yourAction");

    // let domainReqList = [];
    // console.log(domains);
    // for (const domain of domains) {
    //   domainReqList = [...domainReqList, { id: parseInt(domain) }];
    // }
    // console.log("req list",domainReqList);
    // console.log(name);
    if (!name) {
      Toast("Register Details", "Name shouldn't be empty");
      return;
    }
    const pattern = RegExp(/^\+?\d{10,}$/);
    if (!pattern.test(phone)) {
      Toast("Register Details", "Please enter a valid Phone Number");
      return;
    }
    if (!phone) {
      Toast("Register Details", "Phone Number shouldn't be empty");
      return;
    }
    if (!department) {
      Toast("Register Details", "Department shouldn't be empty");
      return;
    }
    if (!domains) {
      Toast("Register Details", "Domain shouldn't be empty");
      return;
    }
    if (!gender) {
      Toast("Register Details", "Gender shouldn't be empty");
      return;
    }
    // console.log("domains",domains);
    const data = {
      name: name,
      phone: phone,
      gender: gender,
      department: department,
      isMentor: isMentor,
      type: type,
      domainList: domains,
      token: localStorage.getItem("regToken"),
      recaptcha: ReCaptchaToken,
    };
    // console.log(localStorage.getItem("regToken"));
    try {
      setUserLoad(true);
      const res = await lcaConfirmProfile(data);
      // console.log(res);
      setUserLoad(false);

      //console.log(res.data.token);
      if (res.status == 200) {
        setOpenReg(false);
        setName("");
        setGender("");
        setDepartment("");
        setDomains([]);
        showNotification({
          title: "Register Details",
          message: "User registered successfully",
          styles: (theme) => ({
            root: {
              backgroundColor: theme.colors.blue[6],
              borderColor: theme.colors.blue[6],

              "&::before": { backgroundColor: theme.white },
            },

            title: { color: theme.white },
            description: { color: theme.white },
            closeButton: {
              color: theme.white,
              "&:hover": { backgroundColor: theme.colors.blue[7] },
            },
          }),
        });
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("id", res.data.user.id);
        localStorage.setItem("type", res.data.user.type);
        setTimeout(() => {
          window.open("/dashboard/announcements", "_self");
        }, 1200);
      }
    } catch (err) {
      // console.log(err);
      setUserLoad(false);
      showNotification({
        title: "Register Details",
        message: `${err.response.data.message}`,
        styles: (theme) => ({
          root: {
            backgroundColor: theme.colors.red[6],
            borderColor: theme.colors.red[6],

            "&::before": { backgroundColor: theme.white },
          },

          title: { color: theme.white },
          description: { color: theme.white },
          closeButton: {
            color: theme.white,
            "&:hover": { backgroundColor: theme.colors.blue[7] },
          },
        }),
      });
    }
  }, [
    executeRecaptcha,
    name,
    phone,
    gender,
    department,
    isMentor,
    type,
    domains,
  ]);

  return (
    <>
      <Modal
        opened={openReg}
        onClose={() => setOpenReg(false)}
        closeOnEscape={false}
        closeOnClickOutside={false}
        withCloseButton={false}
        styles={{
          modal: { backgroundColor: "#fff", color: "#1C3351" },
        }}
      >
        <LoadingOverlay visible={userLoad} />
        {/* Modal content */}

        <Group position="apart">
          <Text style={{ color: "#1C3351" }} size="xl" weight={700}>
            Profile Details
          </Text>
          <Button
            variant="outline"
            radius="md"
            onClick={() => setOpenReg(false)}
            style={{ color: "#1C3351", border: "1px solid #1C3351" }}
          >
            Back to home
          </Button>
        </Group>

        <Text style={{ color: "gray", marginTop: "10px" }} size="sm">
          If your details are incorrect, update your profile details in Lynx
          App.
        </Text>

        <TextInput
          label="Name"
          placeholder="Name"
          value={name}
          styles={{
            input: {
              backgroundColor: "#EFF7FF",
              borderRadius: "5px",
              border: "1px solid #0092E4",
              color: "#0092E4",
              "::placeholder": { color: "#0092E4" },
              fontSize: "15px",
            },
            label: { color: "#1C3351" },
          }}
        />

        <TextInput
          label="Phone Number"
          placeholder="Phone Number"
          value={phone}
          styles={{
            input: {
              backgroundColor: "#EFF7FF",
              borderRadius: "5px",
              border: "1px solid #0092E4",
              color: "#0092E4",
              "::placeholder": { color: "#0092E4" },
              fontSize: "15px",
            },
            label: { color: "#1C3351" },
          }}
        />
        <TextInput
          label="Gender"
          placeholder="Gender"
          value={gender}
          styles={{
            input: {
              backgroundColor: "#EFF7FF",
              borderRadius: "5px",
              border: "1px solid #0092E4",
              color: "#0092E4",
              "::placeholder": { color: "#0092E4" },
              fontSize: "15px",
            },
            label: { color: "#1C3351" },
          }}
        />
        <TextInput
          label="Department"
          placeholder="Department"
          value={department}
          styles={{
            input: {
              backgroundColor: "#EFF7FF",
              borderRadius: "5px",
              border: "1px solid #0092E4",
              color: "#0092E4",
              "::placeholder": { color: "#0092E4" },
              fontSize: "15px",
            },
            label: { color: "#1C3351" },
          }}
        />
        <MultiSelect
          label="Domains"
          placeholder="Choose your domain(s) of interest"
          data={domainList}
          mt="md"
          searchable
          creatable={false}
          getCreateLabel={(query) => `+ Create ${query}`}
          onCreate={(query) =>
            setDomains((currentDomains) => [...currentDomains, query])
          }
          nothingFound="Nothing found..."
          value={domains}
          onChange={handleDomainChange}
          styles={{
            dropdown: {
              backgroundColor: "#1C3351",
            },
            item: { color: "#EFF7FF" },
            hovered: { backgroundColor: "#EFF7FF", color: "#1C3351" },
            input: {
              border: "1px solid #0092E4",
              backgroundColor: "#fff",
            },
            label: { color: "#1C3351" },
            value: {
              border: "1px solid #0092E4",
              backgroundColor: "#EFF7FF",
            },
            description: {
              color: "red",
            },
          }}
        />
        <div style={{ marginTop: "10px" }}>
          <Text style={{ color: "#1C3351" }} size="12px">
            {noteText}
            {readmore && (
            <Text
              style={{ color: "blue", cursor: "pointer"}}
              size="sm"
              onClick={() => {
                setReadmore(false);
                setNoteText(
                  "Note: Software domain includes sub domains like App Development,Networking, Cybersecurity, Blockchain, DevOps. Select Software domain if you are interested in any of these sub domains."
                );
              }}
            >
              Readmore
            </Text>
          )}
          </Text>
          
        </div>
        <Button
          mt="xl"
          size="sm"
          onClick={handleSubmit}
          styles={{
            root: {
              backgroundColor: "#0063F8",
              borderRadius: "20px",
              display: "flex",
              margin: "0 auto",
              padding: "10 20",
            },
          }}
        >
          CONFIRM
        </Button>
      </Modal>

      {/* <Group position="center">
        <Button radius="xl" sx={{ height: 30 }} onClick={() => setOpened(true)}>
          Register
        </Button>
      </Group> */}
    </>
  );
}
